/*
 * socket.io client options shared by every push-style socket. A leaf module by design: worker
 * setup graphs import it (ADR 0016), where pulling in `src/lib/push`'s module-scope
 * StaticContainer logger read would drag main-thread bootstrap into the worker bundle.
 */
import { reviver } from '@thinkalpha/common/serialization/serializer.js';
import type { ManagerOptions, SocketOptions } from 'socket.io-client';
import { Decoder, Encoder } from 'socket.io-parser';

export const CONNECTION_OPTIONS = {
    forceNew: true,
    timeout: 10000,
    transports: ['websocket'],
    parser: {
        Encoder: Encoder,
        Decoder: class extends Decoder {
            constructor() {
                super(reviver);
            }
        },
    },
} satisfies Partial<ManagerOptions & SocketOptions>;
